module.exports = "<div class=\"dialog undo-dialog\">\n  <div mat-dialog-title>{{ description }}</div>\n  <button mat-icon-button class=\"close-button\"\n    (click)=\"close.emit(false)\">\n    <mat-icon>close</mat-icon>\n  </button>\n  <mat-dialog-actions>\n    <span class=\"button_shortcut\">\n      <span class=\"shortcut\">Ctrl+Z</span>\n      <button mat-button (click)=\"close.emit(true)\">\n        Undo\n      </button>\n    </span>\n  </mat-dialog-actions>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/transfers/undo-dialog.component.html
// module id = ./src/app/transfers/undo-dialog.component.html
// module chunks = main